module.exports = __webpack_public_path__ + "img/coverLogo3.73b7e97b.jpg";